import Swiper from "swiper/bundle";

function initCardSwipers(root = document) {
    const swipers = root.querySelectorAll(".card__swiper");

    swipers.forEach((el) => {
        if (el.swiper) {
            el.swiper.destroy(true, true);
        }

        if (!el.querySelector(".swiper-slide")) {
            return;
        }

        const isFullWidth = el.classList.contains("card__swiper--full");
        const isRelated = el.classList.contains("card__swiper--related");
        const desktopSlides = isRelated ? 2.3 : (isFullWidth ? 4 : 3);
        const tabletLandscapeSlides = isRelated ? 2.3 : (isFullWidth ? 3 : 1.8);
        const tabletSlides = 1.2;

        new Swiper(el, {
            slidesPerView: 1.1,
            slidesOffsetBefore: 16,
            spaceBetween: 16,
            watchOverflow: true,
            autoplay: {
                delay: 3000,
                disableOnInteraction: false
            },
            breakpoints: {
                768: {
                    slidesPerView: tabletSlides,
                    spaceBetween: 16
                },
                992: {
                    slidesPerView: tabletLandscapeSlides,
                    spaceBetween: 16
                },
                1199: {
                    slidesPerView: desktopSlides,
                    spaceBetween: 16
                }
            }
        });
    });
}

export { initCardSwipers };
